import {AccountsService} from "../../../Components/Http/Accounts/AccountsService";
import {PageUrlModes} from "../../../Components/Common/pageUrlModes";
import { CacheService } from "../../../Components/Http/Cache/CacheService";

(function($) {

    var profileReimbursementMethodEditPopup = function (profile, depositAccountOnly, updateHeight, successCallback) {
        let reimbursementMethodParam = parseInt($.cdh.helper.urlParam('reimbursementMethod'));
        this.existOpportunityBlock = ko.observable(PageUrlModes.isOpportunity());
        if(this.existOpportunityBlock) {
            PageUrlModes.removeMode();
        }
        this.allowEditReimbursementMethod = ko.observable();
        this.firstLoading = true;
        
        this.isProfile = false;

        this.isBAOVEnabled = String($.cdh.user.baovEnabled).toLowerCase() === 'true';
        this.isFailureAttempt = ko.observable(false);
        this.failureNotes = ko.observable("");
        this.bankAccountContinueSummary = ko.observable(null);
        this.bankAccountInReviewSummary = ko.observable(null);
        
        this.updateHeight = updateHeight;
        this.successCallback = successCallback;
        this.profile = profile;
        if (this.profile.viewModel === undefined) {
            this.profile.viewModel = ko.observable(profile);
        }

        this.profileReimbursementMethod = profile.viewModel().ReimbursementMethod;
        this.bankAccountInReview = profile.viewModel().bankAccountInReview;

        this.ReimbursementMethodList = ko.observableArray();
        this.depositAccountOnly = depositAccountOnly;
        this.editBankAccount = false;
        this.showHsaBillPayMessage=ko.observable(false);
        this.showSaveButton = ko.observable(false);
        this.updateUserReimbursementMethod = ko.observable(true);
        this.bankAccountValidationState = {
            status: ko.observable($.cdh.enums.bankAccountValidationStatus.None),
            statusDescription: ko.observable(''),
            visible: ko.observable(false),
            required: ko.observable(false)
        };
        
        this.bankAccountValidationState.statusTooltipVisible = ko.pureComputed(function () {
            return this.bankAccountValidationState.status() === $.cdh.enums.bankAccountValidationStatus.pendingValidation ||
                this.bankAccountValidationState.status() === $.cdh.enums.bankAccountValidationStatus.validationRequired
        }, this);

        this.isRoutedFromAccountSetup = ko.observable(false);
        this.bankAccountSummary = ko.observable(null);
        this.bankAccountValidation = ko.observable(null);
        this.accountsService = new AccountsService();
        this.anyHsaCurrent = ko.observable();
        this.accountsService.anyHsaCurrentAsync().then(data => this.anyHsaCurrent(data));
        
        this.stateEnum = { oobStep: 10, infoStep: 20  };
        this.displayState = ko.observable(this.stateEnum.oobStep);
        
        this.oobCompleted = function () {
            this.displayState(this.stateEnum.infoStep);
        }.bind(this);

        this.oobCancelled = function () {
            this.clickCancel();
        }.bind(this);

        this.titleText = ko.pureComputed(function () {
            return $.cdh.languageConstant.getConstant('profile.reimbursement-method');
        }, this);

        this.maskSecure = maskSecure;
        
        this.preRender = function () {

            if(this.existOpportunityBlock && !this.firstLoading) {
                this.existOpportunityBlock(false);
            }

            this.displayAdminReviewBankAccount = ko.observable(false);
            this.addBankAccount = new $.cdh.post.profile.addBankAccount();
            this.updateBankAccount = new $.cdh.post.profile.updateBankAccount();
            this.addBankAccountOwnership = new $.cdh.post.profile.addBankAccountOwnership();
            this.updateBankAccountOwnership = new $.cdh.post.profile.updateBankAccountOwnership();
            this.continueBankAccountOwnership = new $.cdh.post.profile.continueBankAccountOwnership();
            this.updateReimbursementMethod = new $.cdh.post.profile.updateReimbursementMethodInfo();
            this.getUserInfo = new $.cdh.get.user.getInfo();
            this.getUserInfo.load().done(result => this.allowEditReimbursementMethod(result.AllowParticipantTransaction));

            this.setBankAccountValidationState(profile.viewModel());

            this.method = {
                ReimbursementMethod: ko.observable(profile.viewModel().ReimbursementMethod),
                Bank: ko.observable(profile.viewModel().Bank),
                BankAccountNumber: ko.observable(profile.viewModel().BankAccountNumber),
                ReBankAccountNumber: ko.observable(''),
                BankRoutingNumber: ko.observable(profile.viewModel().BankRoutingNumber),
                ReBankRoutingNumber: ko.observable(''),
                BankAccountTypeCode: ko.observable(profile.viewModel().BankAccountTypeCode),
                Agree: ko.observable(false),
                Editable: ko.observable(this.depositAccountOnly && this.editBankAccount),
                BankAccountId: ko.observable(profile.viewModel().BankAccountId)
            };
            
            var reimbursementMethodList = profile.viewModel().ReimbursementMethodList;

            if (profile.viewModel().bankAccountInReview) {
                this.displayAdminReviewBankAccount(true);
            }
                
            if (depositAccountOnly) {
                this.ReimbursementMethodList($.grep(reimbursementMethodList,
                    function(r) {
                        return r.ReimbursementMethod == $.cdh.enums.reimbursementMethod.directDeposit;
                    }));
                this.method.ReimbursementMethod($.cdh.enums.reimbursementMethod.directDeposit);
            } else {
                this.ReimbursementMethodList(reimbursementMethodList);
            }
            
            if (this.ReimbursementMethodList().some(r => r.ReimbursementMethod === reimbursementMethodParam)) {
                this.method.ReimbursementMethod(reimbursementMethodParam);
            }

            addValidations(this.method);

            this.validation = new $.cdh.validation(this.method);
            this.validationReimbursement = new $.cdh.validation(this.method.ReimbursementMethod);

            this.method.isVisibleEdit = ko.computed(function() {
                return ko.unwrap(this.method.ReimbursementMethod) == $.cdh.enums.reimbursementMethod.directDeposit;
            }.bind(this));

            this.method.canEdit = ko.computed(function() {
                return $.cdh.employee.allowedToUpdateDirectDepositInformation();
            }.bind(this));

            this.canSubmit = ko.pureComputed(function() {
                var directDeposit = ko.unwrap(this.method.ReimbursementMethod) ==
                    $.cdh.enums.reimbursementMethod.directDeposit;
                if (directDeposit) {
                    return !this.updateReimbursementMethod.isLoading() && !this.validation.hasErrors();
                } else {
                    return !this.updateReimbursementMethod.isLoading() && !this.validationReimbursement.hasErrors();
                }
            }.bind(this));

            if (ko.unwrap(this.method.ReimbursementMethod) == $.cdh.enums.reimbursementMethod.directDeposit) {
                if (this.displayAdminReviewBankAccount() && this.bankAccountInReview) {
                    this.bankAccountInReviewSummary(new profileReimbursementMethodBankAccountInReviewSummary(this, this.bankAccountInReview));
                }
            }

            this.firstLoading = false;
            updateHeight();

        }.bind(this);

        this.afterRender = function () {
            $.cdh.helper.initTabsNavigation(document.getElementById('reim_tabs'), {
                changeTabindex: false,
                changeAriaSelected: false,
            });
        }.bind(this);

        this.setBankAccountValidationState = function(profileVm) {
            this.bankAccountValidationState.status(profileVm.BankAccountValidationStatus);
            this.bankAccountValidationState.statusDescription(profileVm.BankAccountValidationStatusDescription);
            this.bankAccountValidationState.visible(
                profileVm.BankAccountValidationStatus == $.cdh.enums.bankAccountValidationStatus.pendingValidation ||
                profileVm.BankAccountValidationStatus == $.cdh.enums.bankAccountValidationStatus.validationRequired ||
                profileVm.BankAccountValidationStatus == $.cdh.enums.bankAccountValidationStatus.validationFailed
            ),
            this.bankAccountValidationState.required(
                profileVm.BankAccountValidationStatus == $.cdh.enums.bankAccountValidationStatus.validationRequired                
            );
        }.bind(this);
        
        this.enabledValidationInSubmit = ko.pureComputed(function () {
            return (this.method && this.method.Editable())
                || (this.bankAccountValidationState.status() !== $.cdh.enums.bankAccountValidationStatus.pendingValidation &&
                    this.bankAccountValidationState.status() !== $.cdh.enums.bankAccountValidationStatus.active);
        }, this);
        
        this.submitText = ko.pureComputed(function () {
            if (
                this.enabledValidationInSubmit()
                || this.method.ReimbursementMethod() == $.cdh.enums.reimbursementMethod.check
                || this.method.ReimbursementMethod() == $.cdh.enums.reimbursementMethod.connectedCash || this.showSaveButton()
            ) {
                return this.updateReimbursementMethod.isLoading() ? $.cdh.languageConstant.getConstant('button.saving') : $.cdh.languageConstant.getConstant('button.save');
            } else {
                return this.updateReimbursementMethod.isLoading() ? $.cdh.languageConstant.getConstant('button.closing') : $.cdh.languageConstant.getConstant('button.close');
            }
        }, this);

        this.validationActivated = ko.observable(false);
        this.validationReimbursementActivated = ko.observable(false);

        this.resetMethod = function() {
            if (this.updateReimbursementMethod.error()) {
                this.updateReimbursementMethod.error(null);
            }

            this.method.Bank(profile.viewModel().Bank);
            this.method.BankAccountNumber(profile.viewModel().BankAccountNumber);
            this.method.ReBankAccountNumber('');
            this.method.BankRoutingNumber(profile.viewModel().BankRoutingNumber);
            this.method.ReBankRoutingNumber('');
            this.method.BankAccountTypeCode(profile.viewModel().BankAccountTypeCode);
            this.method.Editable(this.depositAccountOnly && this.editBankAccount);
            this.method.BankAccountId(profile.viewModel().BankAccountId);
        }.bind(this);

        this.isBankAccountExist = function () {
            return !!this.method.BankAccountId() || this.bankAccountInReview;
        }.bind(this);

        this.onChangeReimbursementMethod = function(data) {
            this.resetMethod();
            if (data.ReimbursementMethod == $.cdh.enums.reimbursementMethod.directDeposit) {
                this.validationReimbursement.activated(false);
                this.showSaveButton(data.ReimbursementMethod != profile.viewModel().ReimbursementMethod && (this.bankAccountInReview == null || !!this.method.BankAccountId()));
                if (this.validationActivated()) {
                    this.validation.activate();
                }
                if (this.displayAdminReviewBankAccount() && this.bankAccountInReview) {
                    this.bankAccountInReviewSummary(new profileReimbursementMethodBankAccountInReviewSummary(this, this.bankAccountInReview));
                }
                if (!this.isBankAccountExist()) {
                    this.clickEdit(); // Enable edit mode if no bank account exists
                }
            } else {
                this.validation.activated(false);
                if (this.validationReimbursementActivated()) {
                    this.validationReimbursement.activate();
                }
            }
            this.method.ReimbursementMethod(data.ReimbursementMethod);
            updateHeight();
        }.bind(this);

        this.setClose = function(closeFunc) {
            this.close = closeFunc;
        }.bind(this);

        this.diactivateValidation = function() {
            this.validationActivated(false);
            this.validationReimbursementActivated = ko.observable(false);

            this.validation.activated(false);
            this.validationReimbursement.activated(false);
        }.bind(this);

        this.clickEdit = function() {
            this.method.Editable(true);
            this.method.BankRoutingNumber('');
            this.method.BankAccountNumber('');
        }.bind(this);

        this.clickCancel = function() {
            this.diactivateValidation();
            this.resetMethod();
            this.close();
        }.bind(this);
        
        this.ValidateRequiredFields = function(){
            return this.method.Bank() && this.method.BankAccountNumber() && this.method.BankRoutingNumber();
        }

        this.clickSubmit = function() {           
            
            if (!$.cdh.employee.allowedToUpdateDirectDepositInformation())
                return;

            if (this.method.ReimbursementMethod() == $.cdh.enums.reimbursementMethod.directDeposit) {
                if (!this.ValidateRequiredFields()) { 
                    this.validation.activate();
                }
                if (this.enabledValidationInSubmit() && this.method.Editable()) {
                    this.validation.activate();
                    this.validationActivated(true);
                }
            } else {
                this.validationReimbursement.activate();
                this.validationReimbursementActivated(true);
            }

            if (!(this.validation.hasErrors() || this.validationReimbursement.hasErrors())) {

                let bankAccountTypeCode = this.method.ReimbursementMethod() !== $.cdh.enums.reimbursementMethod.directDeposit || !this.method.Editable() 
                    ? this.profile.viewModel().BankAccountTypeCode : this.method.BankAccountTypeCode();
                
                var submitModel = {
                    ReimbursementMethod: this.method.ReimbursementMethod(),
                    Bank: this.method.Bank(),
                    BankAccountNumber: this.method.BankAccountNumber(),
                    BankRoutingNumber: this.method.BankRoutingNumber(),
                    BankAccountTypeCode: bankAccountTypeCode,
                    UpdateUserReimbursementMethod: this.updateUserReimbursementMethod(),
                    BankAccountId: this.method.BankAccountId()
                };

                if (this.method.ReimbursementMethod() == $.cdh.enums.reimbursementMethod.directDeposit) {
                    this.updateReimbursementMethod.error('');
                    this.addBankAccount.error('');
                    this.updateBankAccount.error('');
                    this.addBankAccountOwnership.error('');
                    this.updateBankAccountOwnership.error('');
                    this.continueBankAccountOwnership.error('');

                    this.bankAccountSummary(new profileReimbursementMethodBankAccountSummary(this, submitModel));
                } else {
                    this.method.Editable(this.depositAccountOnly);
                    this.updateReimbursementMethod.load(submitModel)
                        .done(function (result) {
                            if (result) {
                                this.diactivateValidation();
                                this.profile.viewModel().ReimbursementMethod = this.method.ReimbursementMethod();
                                /*
                                this.profile.viewModel().Bank = this.method.Bank();
                                this.profile.viewModel().BankAccountNumber = this.method.BankAccountNumber();
                                this.profile.viewModel().BankRoutingNumber = this.method.BankRoutingNumber();
                                this.profile.viewModel().BankAccountTypeCode = bankAccountTypeCode;
                                this.profile.viewModel(this.profile.viewModel());
                                */

                                if ($.isFunction(this.successCallback))
                                    this.successCallback(this.method.ReimbursementMethod());

                                this.close();
                            }
                        }.bind(this));
                }
            }
            else{
                $(window).scrollTop(0);
            }
        };

        this.clickValidate = function() {
            if (!this.bankAccountValidationState.required())
                return;

            this.setupBankAccountValidation();
        }.bind(this);

        this.setupBankAccountValidation = function () {
            this.bankAccountValidation(new $.cdh.models.ProfileReimbursementMethodBankAccountValidation(this, this.profile));
        }.bind(this);

        function addValidations(data) {
            data.ReimbursementMethod = ko.observable(ko.unwrap(data.ReimbursementMethod)).extend({
                required: true,
                min: 0,
                max: 6
            });
            data.Bank = ko.observable(ko.unwrap(data.Bank)).extend({
                required: true
            });
            data.BankAccountNumber = ko.observable(ko.unwrap(data.BankAccountNumber)).extend({
                required: true,
                betweenLength: { params: [5, 17], message: $.cdh.languageConstant.getConstant('messages.account-number-should-be-numeric') }
            });
            data.ReBankAccountNumber = ko.observable('').extend({
                required: true,
                equal: { params: data.BankAccountNumber, message: $.cdh.languageConstant.getConstant('messages.account-numbers-not-match') }
            });
            data.BankRoutingNumber = ko.observable(ko.unwrap(data.BankRoutingNumber)).extend({
                required: true,
                routingNumber: true
            });
            data.ReBankRoutingNumber = ko.observable('').extend({
                required: true,
                equal: { params: data.BankRoutingNumber, message: $.cdh.languageConstant.getConstant('messages.bank-routing-number-not-match') }
            });
            data.Agree = ko.observable(false).extend({
                checked: {}
            });
            return data;
        }        
    };

    function mapAccountType(type) {
        const t = (type || "").toLowerCase();
        if (t === "checking") return $.cdh.enums.bankAccountType.checking;
        if (t === "savings") return $.cdh.enums.bankAccountType.savings;
        return $.cdh.enums.bankAccountType.none;
    }

    var profileReimbursementMethodBankAccountSummary = function (model, submitModel) {

        this.submitModel = submitModel;
        this.model = model;
        this.continueSubmitModel = null;
        
        this.displayValidationMessage = ko.computed(function() {
            return model.bankAccountValidationState.visible() && model.anyHsaCurrent();
        }, this);

        this.clickCancel = function () {
            model.updateReimbursementMethod.error('');
            model.addBankAccount.error('');
            model.updateBankAccount.error('');
            model.addBankAccountOwnership.error('');
            model.updateBankAccountOwnership.error('');
            model.continueBankAccountOwnership.error('');
            if (model.isFailureAttempt()) {
                model.diactivateValidation();
                model.isFailureAttempt(false);
                model.resetMethod();
                model.bankAccountSummary(null);
                model.close();
            } else {
                model.bankAccountSummary(null);
            }
        };

        this.clickEdit = function () {
            model.updateReimbursementMethod.error('');
            model.addBankAccount.error('');
            model.updateBankAccount.error('');
            model.addBankAccountOwnership.error('');
            model.updateBankAccountOwnership.error('');
            model.continueBankAccountOwnership.error('');
            model.isFailureAttempt(false);
            model.bankAccountSummary(null);
        };
        
        this.clickSave = function () {
            model.updateReimbursementMethod.error('');
            model.addBankAccount.error('');
            model.updateBankAccount.error('');
            model.addBankAccountOwnership.error('');
            model.updateBankAccountOwnership.error('');
            model.continueBankAccountOwnership.error('');

            if (model.isBAOVEnabled) {
                if (!model.method.Editable() && model.profile.viewModel().ReimbursementMethod == $.cdh.enums.reimbursementMethod.check &&
                    !!model.profile.viewModel().Bank && model.profile.viewModel().Bank == submitModel.Bank &&
                    !!model.profile.viewModel().BankAccountNumber && model.profile.viewModel().BankAccountNumber == submitModel.BankAccountNumber &&
                    !!model.profile.viewModel().BankRoutingNumber && model.profile.viewModel().BankRoutingNumber == submitModel.BankRoutingNumber &&
                    model.profile.viewModel().BankAccountTypeCode == submitModel.BankAccountTypeCode && submitModel.BankAccountNumber.length == 4 && submitModel.BankRoutingNumber.length == 4)
                {   
                    // To change only the reimbursement method(Check -> Direct Deposit) without editing bank account details, call the Profile API instead of the V2 Bank Account APIs.
                    model.updateReimbursementMethod.load(submitModel)
                        .done(function (result) {
                            if (result) {
                                model.diactivateValidation();
                                model.profile.viewModel().ReimbursementMethod = model.method.ReimbursementMethod();
                                /*
                                model.profile.viewModel().Bank = model.method.Bank();
                                model.profile.viewModel().BankAccountNumber = model.method.BankAccountNumber();
                                model.profile.viewModel().BankRoutingNumber = model.method.BankRoutingNumber();
                                model.profile.viewModel().BankAccountTypeCode = submitModel.BankAccountTypeCode;
                                model.profile.viewModel().BankAccountValidationStatus = result.BankAccountValidationStatus;
                                model.profile.viewModel().BankAccountValidationStatusDescription = result.BankAccountValidationStatusDescription;
                                model.profile.viewModel(model.profile.viewModel());
                                model.setBankAccountValidationState(model.profile.viewModel());
                                */
                                if ($.isFunction(model.successCallback))
                                    model.successCallback(model.method.ReimbursementMethod());

                                model.resetMethod();
                                model.bankAccountSummary(null);
                                model.close();
                            }
                        }.bind(this));
                }
                else {
                    const bankAccountId = (model.method.BankAccountId() || "").trim();
                    const request = bankAccountId
                        ? model.updateBankAccountOwnership.load(submitModel)
                        : model.addBankAccountOwnership.load(submitModel);

                    request.done(function (result) {
                        if (!result) return;

                        if (!result.hasError && result.data) {
                            var bankAccount = result.data.bankAccount;
                            var notes = result.data.notes.trim();

                            if (notes === "" && bankAccount) {
                                handleSuccess(bankAccount);

                            } else if (notes != "" && !result.data.isPendingReview) {
                                // If there are notes but the account is not pending review, it means the submission failed due to ownership validation failure or other reasons. 
                                // Show the notes to user and allow them to edit or continue to submit for Admin review.
                                model.isFailureAttempt(true);
                                model.failureNotes(notes);
                                this.continueSubmitModel = result.data;

                            } else if (notes != "" && result.data.isPendingReview) {
                                this.continueSubmitModel = result.data;
                                model.bankAccountContinueSummary(new profileReimbursementMethodBankAccountContinueSummary(model, this.continueSubmitModel));
                            }
                        } else {
                            $.cdh.helper.alert2({
                                message: getErrorMessage(result),
                                okVisible: false,
                                cancelVisible: false
                            });
                        }
                    }.bind(this));
                }
            }
            else {

                if (!model.method.Editable() && model.profile.viewModel().ReimbursementMethod == $.cdh.enums.reimbursementMethod.check &&
                    !!model.profile.viewModel().Bank && model.profile.viewModel().Bank == submitModel.Bank &&
                    !!model.profile.viewModel().BankAccountNumber && model.profile.viewModel().BankAccountNumber == submitModel.BankAccountNumber &&
                    !!model.profile.viewModel().BankRoutingNumber && model.profile.viewModel().BankRoutingNumber == submitModel.BankRoutingNumber &&
                    model.profile.viewModel().BankAccountTypeCode == submitModel.BankAccountTypeCode && submitModel.BankAccountNumber.length == 4 && submitModel.BankRoutingNumber.length == 4)
                {
                    // To change only the reimbursement method(Check -> Direct Deposit) without editing bank account details, call the Profile API instead of the V2 Bank Account APIs.
                    model.updateReimbursementMethod.load(submitModel)
                        .done(function (result) {
                            if (result) {
                                model.diactivateValidation();
                                model.profile.viewModel().ReimbursementMethod = model.method.ReimbursementMethod();
                                /*
                                model.profile.viewModel().Bank = model.method.Bank();
                                model.profile.viewModel().BankAccountNumber = model.method.BankAccountNumber();
                                model.profile.viewModel().BankRoutingNumber = model.method.BankRoutingNumber();
                                model.profile.viewModel().BankAccountTypeCode = submitModel.BankAccountTypeCode;
                                model.profile.viewModel().BankAccountValidationStatus = result.BankAccountValidationStatus;
                                model.profile.viewModel().BankAccountValidationStatusDescription = result.BankAccountValidationStatusDescription;
                                model.profile.viewModel(model.profile.viewModel());
                                model.setBankAccountValidationState(model.profile.viewModel());
                                */

                                if ($.isFunction(model.successCallback))
                                    model.successCallback(model.method.ReimbursementMethod());

                                model.resetMethod();
                                model.bankAccountSummary(null);
                                model.close();
                            }
                        }.bind(this));
                }
                else {

                    const bankAccountId = (model.method.BankAccountId() || "").trim();
                    const request = bankAccountId
                        ? model.updateBankAccount.load({ reimbursementMethodInfo: submitModel, bankAccountId })
                        : model.addBankAccount.load(submitModel);

                    request.done(function (result) {
                        if (!result) return;

                        if (!result.hasError && result.data) {
                            handleSuccess(result.data);
                        } else {
                            $.cdh.helper.alert2({
                                message: getErrorMessage(result),
                                okVisible: false,
                                cancelVisible: false
                            });
                        }
                    }.bind(this));
                }
            }
        }

        this.clickContinue = function () {
            model.updateReimbursementMethod.error('');
            model.addBankAccount.error('');
            model.updateBankAccount.error('');
            model.addBankAccountOwnership.error('');
            model.updateBankAccountOwnership.error('');
            model.continueBankAccountOwnership.error('');

            if (!this.continueSubmitModel) return;
            this.continueSubmitModel.isPendingReview = true;

            model.continueBankAccountOwnership.load(this.continueSubmitModel)
                .done(function (result) {
                    if (result?.hasError || !result?.data) return;
                    const { isPendingReview, notes } = result.data;
                    this.continueSubmitModel.isPendingReview = isPendingReview;
                    this.continueSubmitModel.notes = notes;
                    model.bankAccountContinueSummary(new profileReimbursementMethodBankAccountContinueSummary(model, this.continueSubmitModel));
                }.bind(this));
        }

        function mapValidationStatus(statusRaw) {
            const status = (statusRaw || "").replace(/\s+/g, "").toLowerCase();
            const map = {
                new: { val: $.cdh.enums.bankAccountValidationStatus.active, desc: $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.Active') },
                active: { val: $.cdh.enums.bankAccountValidationStatus.active, desc: $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.Active') },
                pendingvalidation: { val: $.cdh.enums.bankAccountValidationStatus.pendingValidation, desc: $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.PendingValidation') },
                validationrequired: { val: $.cdh.enums.bankAccountValidationStatus.validationRequired, desc: $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.ValidationRequired') },
                validationfailed: { val: $.cdh.enums.bankAccountValidationStatus.validationFailed, desc: $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.ValidationFailed') }
            };
            return map[status] || { val: $.cdh.enums.bankAccountValidationStatus.none, desc: statusRaw };
        }

        function getErrorMessage(result) {
            const fieldMsg = result?.error?.details?.fieldErrors?.[0]?.message;
            return (fieldMsg && fieldMsg.trim()) ? fieldMsg : (result?.error?.message || "");
        }

        function handleSuccess(bankAccount) {
            model.diactivateValidation();

            const vm = model.profile.viewModel();
            vm.ReimbursementMethod = model.method.ReimbursementMethod();
            vm.Bank = bankAccount.name;
            vm.BankAccountNumber = model.isBAOVEnabled ? bankAccount.accountNumber : bankAccount.maskedAccountNumber;
            vm.BankRoutingNumber = model.isBAOVEnabled ? bankAccount.routingNumber : bankAccount.maskedRoutingNumber;
            vm.BankAccountId = model.isBAOVEnabled ? bankAccount.evaluationId : bankAccount.bankAccountId;
            vm.BankAccountTypeCode = mapAccountType(bankAccount.accountType);

            if (model.isBAOVEnabled) {
                vm.BankAccountValidationStatus = $.cdh.enums.bankAccountValidationStatus.active;
                vm.BankAccountValidationStatusDescription = $.cdh.languageConstant.getConstant('BankAcctValStatusDesc.Active');
            } else {
                const mapped = mapValidationStatus(bankAccount.status);
                vm.BankAccountValidationStatus = mapped.val;
                vm.BankAccountValidationStatusDescription = mapped.desc;
            }

            model.profile.viewModel(vm);
            model.setBankAccountValidationState(vm);

            if ($.isFunction(model.successCallback))
                model.successCallback(model.method.ReimbursementMethod());

            model.resetMethod();
            model.bankAccountSummary(null);
            model.close();
        }

    }.bind(this);

    var profileReimbursementMethodBankAccountContinueSummary = function (model, continueModel) {
        model.updateReimbursementMethod.error('');
        model.addBankAccount.error('');
        model.updateBankAccount.error('');
        model.addBankAccountOwnership.error('');
        model.updateBankAccountOwnership.error('');
        model.continueBankAccountOwnership.error('');

        this.continueModel = continueModel;
        this.model = model;

        if ($.isFunction(model.successCallback))
            model.successCallback(model.profile.viewModel().ReimbursementMethod);

        this.clickContinue = function () {
            model.diactivateValidation();
            model.isFailureAttempt(false);
            model.resetMethod();
            model.bankAccountSummary(null);
            model.bankAccountContinueSummary(null);
            model.close();
        }
    };

    var profileReimbursementMethodBankAccountInReviewSummary = function (model, accountInReviewModel) {
        this.accountInReviewModel = accountInReviewModel;
        this.bankAccount = accountInReviewModel.bankAccount;
        this.model = model;
        this.bankAccount.bankAccountTypeCode = mapAccountType(this.bankAccount.accountType);

        this.clickOk = function () {
            model.displayAdminReviewBankAccount(false);
            model.bankAccountInReviewSummary(null);
            if (model.bankAccountValidationState.status() != $.cdh.enums.bankAccountValidationStatus.active) {
                model.diactivateValidation();
                model.resetMethod();
                model.close();
            }
        }
    };

    var profileReimbursementMethodBankAccountValidation = function(model, profile) {

        this.validationModel = {
            amount1: ko.observable(0).extend({ required: true, min: -0.99, max: 0.99 }),
            amount2: ko.observable(0).extend({ required: true, min: -0.99, max: 0.99 }),
            amount3: ko.observable(0).extend({ required: true, min: -0.99, max: 0.99 })
        };

        this.amountValidation = new $.cdh.validation(this.validationModel);

        this.resultMessage = ko.observable('');
        this.sucessSubmit = ko.observable(false);

        this.submitRequest = new $.cdh.post.profile.validateBankAccount();

        this.clickSubmit = function() {

            this.resultMessage('');

            this.amountValidation.activate();
            if (this.amountValidation.hasErrors())
                return;

            if (!this.canBeSubmitted())
                return;

            this.submitRequest
                .load({
                    amount1: this.validationModel.amount1(),
                    amount2: this.validationModel.amount2(),
                    amount3: this.validationModel.amount3()
                })
                .done(function(response) {
                    this.resultMessage(response.Message);
                    this.sucessSubmit(response.SucessSubmit);
                    this.amountValidation.deactivate();

                    if (response.SucessSubmit) {
                        var employee = response.Employee;
                        profile.viewModel().BankAccountValidationStatus = employee.BankAccountValidationStatus;
                        profile.viewModel().BankAccountValidationStatusDescription =
                            employee.BankAccountValidationStatusDescription;
                        model.setBankAccountValidationState(profile.viewModel());
                    }
                }.bind(this));

        }.bind(this);

        this.canBeSubmitted = ko.pureComputed(function() {
            return !this.amountValidation.hasErrors();
        }.bind(this));

        this.clickOk = function () {
            // Code changes added only when the Bank Account Validation is successfull done
            // through Account activity flow the page should be reloaded on click of OK button
            // to show the updated information by clearing only the profile cache.
            if (model.isRoutedFromAccountSetup()) {
                new CacheService().clearAsync(4, {}).done(window.location.reload());
            }
            this.clickCancel();
        }.bind(this);

        this.clickCancel = function() {
            model.bankAccountValidation(null);
        }.bind(this);
    };

    function maskSecure (text) {
        const value = ko.isObservable(text) ? text() : text;
        if (value === undefined || value.length < 4) 
            return value;
        
        var hiddenChars = 9-value.length;
        var newText = "";
        for (var i = 0; i < hiddenChars; ++i)
            newText = newText.concat("*")
            
        newText = newText.concat(value);
        return newText;
    }
    
    $.extend(true, $,
        {
            cdh: {
                models: {
                    ProfileReimbursementMethodBankAccountInReviewSummary: profileReimbursementMethodBankAccountInReviewSummary,
                    ProfileReimbursementMethodEditPopup: profileReimbursementMethodEditPopup,
                    ProfileReimbursementMethodBankAccountSummary: profileReimbursementMethodBankAccountSummary,
                    ProfileReimbursementMethodBankAccountValidation: profileReimbursementMethodBankAccountValidation,
                    ProfileReimbursementMethodBankAccountContinueSummary: profileReimbursementMethodBankAccountContinueSummary
                }
            }
        });
    }(jQuery));